<template>
  <section class="privacy_page aboutBeatday">
    <div class="paragraph">
      <h1>{{ $t('about-us.key002') }}</h1>
      <img src="@/assets/img/public/BEATDAY_AlternateLogo_Multicolor.svg" alt="BEATDAY_logo" />
      <p>
        {{ $t('about-beatday.key001') }}
      </p>
      <p>
        {{ $t('about-beatday.key004') }}<i class="bi bi-youtube" style="line-height: 1.4; color: #f91533; margin: 0"></i>
        <a href="https://www.youtube.com/channel/UCtZsfDkAPwPqOzlENXSjFPA" target="_blank">BEATDAY - Youtube</a>
      </p>
    </div>
    <div class="paragraph">
      <h1>{{ $t('about-beatday.key002') }}</h1>
      <a href="https://viveoriginals.com/" target="_blank">
        <img src="@/assets/img/public/VIVE_Originals_AlternateLogo_Digital_Primary_multicolor_White.svg" alt="VIVE_Originals_logo" class="VIVE_Originals" />
      </a>
      <p v-html="formattedMessageKey003"></p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AboutBeatday',
  components: {},
  mounted() {},
  data() {
    return {};
  },
  props: {},
  computed: {
    formattedMessageKey003() {
      return this.$t('about-beatday.key003', {
        ViveOriginalsWebLink: '<a href="https://viveoriginals.com/" target="_blank">https://viveoriginals.com/</a>',
      });
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
